import { Injectable } from '@angular/core';
import { ILoginModel, IAuthenticatedModel } from './login.models';
import { BehaviorSubject, Observable } from 'rxjs';
import { EndpointConstants } from 'src/app/core/services/endpoints-configurations/endpoint-constants';
import { HttpClientRequestService } from '@core/request-services/httpclient.request.services';

@Injectable({ providedIn: 'root' })
export class LoginService {
  public initialLogin$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClientRequestService) {}

  login(payload: ILoginModel): Observable<IAuthenticatedModel> {
    const url = EndpointConstants.ApiLogin;
    return this.http.post<IAuthenticatedModel>(url, payload);
  }
}
